<template>
  <div class="flex flex-col w-1/2 mt-10 mb-16 print:hidden">
    <hr class="mt-4 mb-4 border-t border-gray-400 w-full" />

    <div>
      <MainButton
        :title="nextpagetext"
        purple
        medium
        shadow
        @click="nextPage()"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'NavigationBottom',
  props: {
    nextpagetext: {
      type: String,
      default: null
    },
    nextpageurl: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState
  },
  methods: {
    nextPage() {
      //if(this.nextpageurl == "Bank-Details")
      this.$router.push(this.nextpageurl);
      this.scrollToTop();
    }
  }
};
</script>
